/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { RM2, RM2Interface } from "../RM2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "rewardToken_",
        type: "address",
      },
      {
        internalType: "address",
        name: "provider_",
        type: "address",
      },
      {
        internalType: "contract IVPToken",
        name: "vpToken_",
        type: "address",
      },
      {
        internalType: "contract IFtsoManager",
        name: "ftsoManager_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "VALIDREWARDEPOCH",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "claimAllRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardEpoch",
        type: "uint256",
      },
    ],
    name: "claimReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardEpoch",
        type: "uint256",
      },
    ],
    name: "claimable",
    outputs: [
      {
        internalType: "bool",
        name: "isClaimable",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "claimedStatus",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "firstRewardEpoch",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "flipPaused",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "who",
        type: "address",
      },
    ],
    name: "getClaimableEpochs",
    outputs: [
      {
        internalType: "uint256[]",
        name: "claimableEpochs",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "beneficiary",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardEpoch",
        type: "uint256",
      },
    ],
    name: "getRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "provider",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ratio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_epochId",
        type: "uint256",
      },
    ],
    name: "setFirstRewardEpoch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IFtsoManager",
        name: "ftsoManager_",
        type: "address",
      },
    ],
    name: "setFtsoManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_provider",
        type: "address",
      },
    ],
    name: "setProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "ratio_",
        type: "uint256",
      },
    ],
    name: "setRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "threshold_",
        type: "uint256",
      },
    ],
    name: "setThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IVPToken",
        name: "vpToken_",
        type: "address",
      },
    ],
    name: "setVpToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "threshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type RM2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RM2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RM2__factory extends ContractFactory {
  constructor(...args: RM2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    rewardToken_: PromiseOrValue<string>,
    provider_: PromiseOrValue<string>,
    vpToken_: PromiseOrValue<string>,
    ftsoManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<RM2> {
    return super.deploy(
      rewardToken_,
      provider_,
      vpToken_,
      ftsoManager_,
      overrides || {}
    ) as Promise<RM2>;
  }
  override getDeployTransaction(
    rewardToken_: PromiseOrValue<string>,
    provider_: PromiseOrValue<string>,
    vpToken_: PromiseOrValue<string>,
    ftsoManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      rewardToken_,
      provider_,
      vpToken_,
      ftsoManager_,
      overrides || {}
    );
  }
  override attach(address: string): RM2 {
    return super.attach(address) as RM2;
  }
  override connect(signer: Signer): RM2__factory {
    return super.connect(signer) as RM2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RM2Interface {
    return new utils.Interface(_abi) as RM2Interface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): RM2 {
    return new Contract(address, _abi, signerOrProvider) as RM2;
  }
}
